import { render, staticRenderFns } from "./OpenBillingContacts.vue?vue&type=template&id=88bfff1e&scoped=true&"
import script from "./OpenBillingContacts.vue?vue&type=script&lang=js&"
export * from "./OpenBillingContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bfff1e",
  null
  
)

export default component.exports